import { Component } from '@angular/core';

@Component({
  selector: 'app-redirect-link-pages',
  templateUrl: './redirect-link-pages.component.html',
  styleUrls: ['./redirect-link-pages.component.scss'],
})
export class RedirectLinkPagesComponent {}
